import { Injectable } from "@angular/core";
import { BaseDataResponse, BaseEntitiesResponse, BaseEntityResponse, GenericListEntity, Notification, NotificationListParams, NotificationTemplateListView, RenderedTemplate } from '@base/entities/BaseEntities';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { BaseEndpoint } from "@m4u-angular/base/endpoint/BaseEndpoint";
import { Observable } from "rxjs";
import { APIGatewayService } from "../gateway/APIGateway.service";
import { EnumNotificationDeliveryOptions } from '@core/framework/sysenums.enum';


@Injectable()
export class ShareEndpoint extends BaseEndpoint {
    //Constructor
    constructor(api: APIGatewayService) {
        super("Share", api);
    }

    public GetRenderedTemplate(NotificationTemplateID: number, DeliveryOption: EnumNotificationDeliveryOptions): Observable<BaseEntityResponse<RenderedTemplate>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetRenderedTemplate', { NotificationTemplateID: NotificationTemplateID, DeliveryOption: DeliveryOption });
    }

    public GetNotificationsTemplates(): Observable<BaseEntitiesResponse<NotificationTemplateListView>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetNotificationsTemplates', {});
    }
}
